import { useEffect } from 'react';

const SEO = () => {
  useEffect(() => {
    // Update page title
    document.title = "Tesla's Academy - Best Tuition Classes in Tirupur & Coimbatore | CBSE, ICSE, IGCSE, IB Coaching";
    
    // Update or create meta tags
    const updateMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Basic SEO Meta Tags
    updateMetaTag('description', 
      'Tesla\'s Academy offers expert tuition for Grade 1-12 across CBSE, Matric, IGCSE, ICSE & IB boards. 10+ years experience, 1000+ successful students. 4 branches in Tirupur & Coimbatore. Enroll now!'
    );
    
    updateMetaTag('keywords', 
      'tuition classes Tirupur, coaching center Coimbatore, CBSE coaching, ICSE tutoring, IGCSE classes, IB preparation, board exam coaching, entrance exam preparation, JEE coaching, NEET coaching, best academy Tirupur, personalized tutoring'
    );
    
    updateMetaTag('author', 'Tesla\'s Academy');
    updateMetaTag('robots', 'index, follow');
    updateMetaTag('language', 'English');
    updateMetaTag('revisit-after', '7 days');
    updateMetaTag('distribution', 'global');
    updateMetaTag('rating', 'general');
    
    // Open Graph Meta Tags (Facebook, LinkedIn)
    updateMetaTag('og:title', 'Tesla\'s Academy - Knowledge is Power | Best Coaching in Tirupur & Coimbatore', true);
    updateMetaTag('og:description', 
      'Empowering students since 2015 with expert tuition for all standards and syllabi. Join 1000+ successful students at Tesla\'s Academy.',
      true
    );
    updateMetaTag('og:type', 'website', true);
    updateMetaTag('og:url', 'https://www.teslasacademy.com/', true);
    updateMetaTag('og:image', 'https://www.teslasacademy.com/logo.png', true);
    updateMetaTag('og:site_name', 'Tesla\'s Academy', true);
    updateMetaTag('og:locale', 'en_IN', true);
    
    // Twitter Card Meta Tags
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', 'Tesla\'s Academy - Best Tuition in Tirupur & Coimbatore');
    updateMetaTag('twitter:description', 
      'Expert coaching for CBSE, ICSE, IGCSE, IB. 10+ years experience. Enroll now!'
    );
    updateMetaTag('twitter:image', 'https://www.teslasacademy.com/logo.png');
    
    // Mobile Optimization
    updateMetaTag('viewport', 'width=device-width, initial-scale=1.0, maximum-scale=5.0');
    updateMetaTag('format-detection', 'telephone=yes');
    updateMetaTag('apple-mobile-web-app-capable', 'yes');
    updateMetaTag('apple-mobile-web-app-status-bar-style', 'black-translucent');
    
    // Geo Tags for Local SEO
    updateMetaTag('geo.region', 'IN-TN');
    updateMetaTag('geo.placename', 'Tirupur, Coimbatore');
    updateMetaTag('geo.position', '11.1085;77.3411'); // Tirupur coordinates
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://www.teslasacademy.com/');
    
    // Structured Data - Organization
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "EducationalOrganization",
      "name": "Tesla's Academy",
      "alternateName": "Teslas Academy",
      "url": "https://www.teslasacademy.com",
      "logo": "https://www.teslasacademy.com/logo.png",
      "description": "Premier coaching institute offering tuition for Grade 1-12 across multiple boards including CBSE, ICSE, IGCSE, IB, and Matric.",
      "foundingDate": "2015",
      "slogan": "Knowledge is Power",
      "telephone": "+91-98765-43210",
      "email": "info@teslasacademy.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "123, Knowledge Street, Near Central Park",
        "addressLocality": "Tirupur",
        "addressRegion": "Tamil Nadu",
        "postalCode": "641601",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "11.1085",
        "longitude": "77.3411"
      },
      "sameAs": [
        "https://www.facebook.com/teslasacademy",
        "https://www.instagram.com/teslasacademy",
        "https://www.youtube.com/teslasacademy",
        "https://www.linkedin.com/company/teslasacademy"
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "250"
      }
    };
    
    // Structured Data - Local Business (Multiple Locations)
    const locationsSchema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "LocalBusiness",
          "name": "Tesla's Academy - Tirupur Main Branch",
          "image": "https://www.teslasacademy.com/images/branches/tirupur-main.jpg",
          "telephone": "+91-98765-43210",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "123, Knowledge Street, Near Central Park",
            "addressLocality": "Tirupur",
            "addressRegion": "Tamil Nadu",
            "postalCode": "641601",
            "addressCountry": "IN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "11.1085",
            "longitude": "77.3411"
          },
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
              "opens": "08:00",
              "closes": "20:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "Tesla's Academy - Coimbatore RS Puram",
          "telephone": "+91-98765-43212",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "789, Scholar Lane",
            "addressLocality": "Coimbatore, RS Puram",
            "addressRegion": "Tamil Nadu",
            "postalCode": "641002",
            "addressCountry": "IN"
          }
        }
      ]
    };
    
    // Structured Data - Courses Offered
    const coursesSchema = {
      "@context": "https://schema.org",
      "@type": "Course",
      "name": "Comprehensive Tuition Program",
      "description": "Expert coaching for Grade 1-12 covering CBSE, ICSE, IGCSE, IB, and Matric boards",
      "provider": {
        "@type": "Organization",
        "name": "Tesla's Academy",
        "sameAs": "https://www.teslasacademy.com"
      },
      "educationalLevel": "Grade 1 to Grade 12",
      "coursePrerequisites": "None",
      "offers": {
        "@type": "Offer",
        "category": "Education",
        "priceCurrency": "INR"
      }
    };
    
    // Structured Data - BreadcrumbList
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.teslasacademy.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Programs",
          "item": "https://www.teslasacademy.com/#programs"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Achievements",
          "item": "https://www.teslasacademy.com/#achievements"
        }
      ]
    };
    
    // Insert structured data
    const insertStructuredData = (schema, id) => {
      let script = document.getElementById(id);
      if (!script) {
        script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = id;
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    };
    
    insertStructuredData(organizationSchema, 'organization-schema');
    insertStructuredData(locationsSchema, 'locations-schema');
    insertStructuredData(coursesSchema, 'courses-schema');
    insertStructuredData(breadcrumbSchema, 'breadcrumb-schema');
    
  }, []);
  
  return null; // This component doesn't render anything
};

export default SEO;
